<template>
  <main class="sf-page">
    <div class="sf-page-hero">
      <div class="sf-page-hero__inner" data-aos="fade-up">
        <p class="sf-page-hero__eyebrow"><span class="sf-page-hero__eyebrow-dot"></span>Les visages de la fondation</p>
        <h1 class="sf-h1">Notre <em>Équipe</em></h1>
        <p class="sf-page-hero__sub">Des professionnels passionnés engagés pour l'impact social et la transformation numérique.</p>
      </div>
    </div>

    <!-- Filters -->
    <section class="sf-section sf-section--cream" style="padding-bottom:0">
      <div class="sf-container">
        <div class="sf-filters">
          <button class="sf-pill" :class="{'sf-pill--active':selectedDepartment===''}" @click="selectedDepartment=''">Tous</button>
          <button v-for="dept in departments" :key="dept" class="sf-pill" :class="{'sf-pill--active':selectedDepartment===dept}" @click="selectedDepartment=dept">{{ dept }}</button>
        </div>
      </div>
    </section>

    <section class="sf-section sf-section--cream">
      <div class="sf-container">
        <div v-if="loading" class="sf-loader"><span class="sf-loader__ring"></span></div>
        <div v-else class="tm-grid">
          <div v-for="(m, i) in filteredMembers" :key="m.id" class="tm-card" data-aos="fade-up" :data-aos-delay="i*60">
            <div class="tm-card__media">
              <img v-if="m.avatar" :src="imageUrl+m.avatar" :alt="m.last_name+''+m.first_name" loading="lazy" />
              <div v-else class="tm-card__initials">{{ m.initials }}</div>
              <div class="tm-card__socials">
                <a v-if="m.linkedin" :href="m.linkedin" target="_blank" class="tm-social"><Linkedin /></a>
                <a v-if="m.twitter" :href="m.twitter" target="_blank" class="tm-social"><Twitter /></a>
                <a v-if="m.github" :href="m.github" target="_blank" class="tm-social"><Github /></a>
              </div>
            </div>
            <div class="tm-card__body">
              <h3 class="tm-card__name">{{m.last_name}} {{ m.first_name }}</h3>
              <p class="tm-card__position">{{ m.position }}</p>
              <p class="tm-card__dept">{{ m.department }}</p>
            </div>
          </div>
        </div>

        <div v-if="pagination.last_page>1" class="sf-pagination">
          <button class="sf-page-btn" :disabled="pagination.current_page===1" @click="changePage(pagination.current_page-1)"><ChevronLeft /></button>
          <button v-for="p in displayedPages" :key="p" class="sf-page-btn" :class="{'sf-page-btn--active':pagination.current_page===p}" @click="changePage(p)">{{ p }}</button>
          <button class="sf-page-btn" :disabled="pagination.current_page===pagination.last_page" @click="changePage(pagination.current_page+1)"><ChevronRight /></button>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AOS from 'aos'; import 'aos/dist/aos.css'
import { ChevronLeft, ChevronRight, Linkedin, Twitter, Github } from 'lucide-vue-next'
export default {
  name:'TeamPage',
  components:{ ChevronLeft, ChevronRight, Linkedin, Twitter, Github },
  data(){return{selectedDepartment:'',displayedPages:[]}},
  computed:{
    ...mapState({loading:s=>s.loading,teamMembers:s=>s.teamMembers,departments:s=>s.teamMemberDepartments,pagination:s=>s.teamMembersPagination,imageUrl:s=>s.imageUrl}),
    filteredMembers(){return this.selectedDepartment?this.teamMembers.filter(m=>m.department===this.selectedDepartment):this.teamMembers}
  },
  watch:{'pagination.last_page':{handler(){this.updateDisplayedPages()},immediate:true},selectedDepartment(){this.changePage(1)}},
  created(){this.loadData()},
  mounted(){AOS.init({once:true,offset:70,easing:'ease-out-cubic',duration:650})},
  methods:{
    ...mapActions(['fetchPublicTeamMembers','fetchTeamMemberDepartments']),
    async loadData(){await Promise.all([this.fetchPublicTeamMembers(),this.fetchTeamMemberDepartments()])},
    changePage(p){if(p>=1&&p<=this.pagination.last_page){this.$store.commit('SET_TEAM_MEMBER_PAGE',p);this.loadData()}},
    updateDisplayedPages(){const c=this.pagination.current_page,l=this.pagination.last_page,d=2;let pg=[];for(let i=1;i<=l;i++){if(i===1||i===l||(i>=c-d&&i<=c+d))pg.push(i)}this.displayedPages=pg}
  }
}
</script>
<style>@import './sf-design.css';</style>
<style scoped>
.tm-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:1.5rem}
.tm-card{background:var(--white);border-radius:8px;overflow:hidden;box-shadow:var(--shadow-sm);transition:transform .3s ease,box-shadow .3s ease}
.tm-card:hover{transform:translateY(-4px);box-shadow:var(--shadow-md)}
.tm-card__media{position:relative;height:240px;background:var(--cream-d);overflow:hidden}
.tm-card__media img{width:100%;height:100%;object-fit:cover;transition:transform .6s ease}
.tm-card:hover .tm-card__media img{transform:scale(1.06)}
.tm-card__initials{width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-family:var(--fd);font-size:3.5rem;font-weight:700;color:var(--terra);background:linear-gradient(135deg,var(--cream-d),var(--cream))}
.tm-card__socials{position:absolute;inset:0;background:rgba(27,58,45,.75);opacity:0;transition:opacity .3s ease;display:flex;align-items:center;justify-content:center;gap:.6rem}
.tm-card:hover .tm-card__socials{opacity:1}
.tm-social{width:38px;height:38px;border-radius:50%;background:var(--white);display:flex;align-items:center;justify-content:center;transition:background .2s ease}
.tm-social:hover{background:var(--terra)}
.tm-social:hover :deep(svg){color:var(--white)}
.tm-social :deep(svg){width:16px;height:16px;color:var(--forest)}
.tm-card__body{padding:1.25rem}
.tm-card__name{font-family:var(--fd);font-size:1.15rem;font-weight:600;color:var(--ink);margin-bottom:.2rem}
.tm-card__position{font-size:.84rem;font-weight:500;color:var(--terra);margin-bottom:.15rem}
.tm-card__dept{font-size:.78rem;color:var(--ink-60)}
</style>
